//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import { ReactComponent as Down } from "../../../../Media/Icon/010.svg";

//Element
class Submenu extends Component {
    //Element
    onClick = (e) => {
        //Element
        e.preventDefault()
        //Element
        console.log(e)
        //Element
        e.target.nextElementSibling.classList.toggle("d-block")
        //Element
        e.nativeEvent.target.classList.toggle("border-0")

    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j11251 d-none" },
            //Element
            React.createElement(Container, {},
                //Element
                React.createElement(Row, {},
                    //Element
                    React.createElement(Col, { md: 12 },
                        //Element
                        React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c008vi" },
                            //Element
                            React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB x3914c" },
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en" },
                                        //Element
                                        "Home"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/", onClick: this.onClick },
                                        //Element
                                        "Corporate",
                                        //Element
                                        React.createElement(Down, {})
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/about-us" },
                                                //Element
                                                "About Us"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/history" },
                                                //Element
                                                "History"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/offices" },
                                                //Element
                                                "Offices"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/authorization-certificates" },
                                                //Element
                                                "Certificates"
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/", onClick: this.onClick },
                                        //Element
                                        "Services",
                                        //Element
                                        React.createElement(Down, {})
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/lighting-systems" },
                                                //Element
                                                "Lighting Systems"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/electrical-panel-manufacturing" },
                                                //Element
                                                "Electrical Panel Manufacturing"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/electrical-contracting" },
                                                //Element
                                                "Electrical Contracting"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/renewable-energy" },
                                                //Element
                                                "Renewable Energy"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/medium-voltage-systems" },
                                                //Element
                                                "Medium Voltage Systems"
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/projects" },
                                        //Element
                                        "Projects"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/sustainability" },
                                        //Element
                                        "Sustainability"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/career" },
                                        //Element
                                        "Career"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en/contact" },
                                        //Element
                                        "Contact"
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Submenu;